module.exports = __webpack_public_path__ + "static/img/12.09ef8f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/12.png
// module id = FUCY
// module chunks = 13